module.exports = __webpack_public_path__ + "img/40_38_081_370.08d4c854.jpg";